var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('my-header'),_vm._m(0),_c('my-footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"banner"},[_c('p',[_vm._v("公司动态")]),_c('div')]),_c('div',{staticClass:"content"})])
}]

export { render, staticRenderFns }